// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CardsViewLoadingState-base___TlSK{display:flex;flex-direction:column;gap:var(--size-4);width:var(--size-full);margin-bottom:var(--bottom-bar-height);padding:var(--size-4) var(--size-4) 0;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "CardsViewLoadingState-base___TlSK"
};
export default ___CSS_LOADER_EXPORT___;
